"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarMenuMore = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ToolbarItem_1 = require("../ToolbarItem");
const ToolbarMenuPopup_1 = require("./ToolbarMenuPopup");
const context_1 = require("./context");
const Iconista_1 = require("../../../icons/Iconista");
const useBehaviorSubject_1 = require("../../../hooks/useBehaviorSubject");
const context_2 = require("../../../context");
const ToolbarMenuMore = ({ item, disabled }) => {
    const [t] = (0, use_t_1.useT)();
    const openPanel = (0, context_1.useToolbarMenu)()?.openPanel;
    (0, useBehaviorSubject_1.useBehaviorSubjectOpt)(openPanel?.selected$);
    const subtle = (0, context_2.useSubtleTrace)();
    const id = item.id ?? item.name;
    const selected = openPanel?.isSelected(id) ?? false;
    return (React.createElement(ToolbarMenuPopup_1.ToolbarMenuPopup, { open: selected, item: item },
        React.createElement("div", { style: { height: 32, display: 'flex', alignItems: 'center' } },
            React.createElement(ToolbarItem_1.ToolbarItem, { fill: !subtle, narrow: true, skewed: false, height: 28, disabled: disabled, selected: selected, onMouseEnter: disabled ? void 0 : () => openPanel?.onMouseMove(id), onMouseMove: disabled ? void 0 : () => openPanel?.onMouseMove(id), onMouseLeave: disabled ? void 0 : openPanel?.onMouseLeave, onClick: disabled ? void 0 : () => openPanel?.onClick(id), tooltip: {
                    renderTooltip: item.name ? () => t(item.name) : void 0,
                } },
                React.createElement(Iconista_1.Iconista, { width: 16, height: 16, set: 'tabler', icon: 'dots-vertical', style: { opacity: 0.5 } })))));
};
exports.ToolbarMenuMore = ToolbarMenuMore;
